import React from 'react';
import {
    Icon
} from 'antd';

export default function SelectPlaceHolder(props) {
    return (
        <div><Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />&nbsp; {props.label}</div>
    );
}